'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
// Capitalise the first character of a string.
var capitalize = exports.capitalize = function capitalize(str) {
  if (!str) return '';
  return str[0].toUpperCase() + str.substr(1);
};

var JWTDecode = exports.JWTDecode = function JWTDecode(token) {
  var _token$split = token.split('.'),
      _token$split2 = _slicedToArray(_token$split, 2),
      discardedPart = _token$split2[0],
      base64Url = _token$split2[1]; // eslint-disable-line no-unused-vars


  if (!base64Url) return null;
  var base64 = base64Url.replace('-', '+').replace('_', '/');
  var decoded = safeJSONParse(window.atob(base64));
  if (!decoded) return null;
  return (typeof decoded === 'undefined' ? 'undefined' : _typeof(decoded)) !== 'object' ? null : decoded;
};

/*
 * Generates a random string. This is used for encoding DOM attributes.
 */
var randomHash = exports.randomHash = function randomHash() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var text = '';

  for (var i = 0; i < len; i += 1) {
    text += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return prefix + text;
};

/*
 * @param {String} json Value to parse.
 * @param {Any} fallback If defined, we return this value if parsing throws
 *  error and the original argument isn't a JSON object.
 *
 * @return A valid JSON schema or the original parameter value.
 */
var safeJSONParse = exports.safeJSONParse = function safeJSONParse(json, fallback) {
  var parsed = void 0;
  try {
    parsed = JSON.parse(json);
  } catch (e) {
    var isJSON = (typeof json === 'undefined' ? 'undefined' : _typeof(json)) === 'object' && !Array.isArray(json);
    parsed = !isJSON && fallback !== undefined ? fallback : json;
  }
  return parsed;
};